import axios from 'axios'
import Config from '@/config'
import { Notification, Message } from 'element-ui'

// 创建axios实例
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
const service = axios.create({
  baseURL: Config.apiUrl,
  withCredentials: true,
  // 超时
  timeout: 1000 * 60 * 60 * 5
})
// request拦截器
service.interceptors.request.use(
  config => {
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        var part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              const params = propName + '[' + key + ']'
              var subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(
  res => {
    if (res.status === 200) {
      return res;
    } else {
      Message.error(res.data.message || '网络异常')
      return Promise.reject(res)
    }
  },
  error => {
    console.log(error)
    // return Promise.reject(error)
  }
)
export const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    service.get(url, { params }).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}
export const post = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    service.post(url, params).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}

export default { service,get,post }
